import React, { useState } from 'react';
import { Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { HeaderModal, InputConsensus, ButtonConsensus } from 'components';
import { colors } from 'utils/colorsSteps';
import { toast } from 'react-toastify';
import organService from 'services/organ/organService';
import movementTaskService from 'services/movement-task/movementTaskService';
import LazyAutocomplete from 'components/LazyAutocomplete';
import { AutoCompleteConfig } from 'constants/autocomplete';
import { ACT_TYPES } from 'constants/subtypes/subtypes';

const ModalIntimationToComplaint = props => {
  const { open, onClose, inquiry } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [key, setKey] = useState(false);
  const [sendRequest, setSendRequest] = useState(false);

  const initialValues = {
    place: null,
    inquiryInvestigatedId: inquiry.id,
    shouldMoveInquiry: true,
    type: 'DENUNCIA',
    subType: {
      code: '920015',
      name: 'Denúncia',
      act: ACT_TYPES.FINALISTIC,
    },
  };

  const [formState, setFormState] = useState({ ...initialValues });

  const fetchDelegacias = async (search, page) => {
    const params = {
      page,
      size: AutoCompleteConfig.PAGINATION_SIZE,
      search,
    };
    const result = await organService.getDelegaciasService(params);

    return {
      data: result.data.data,
      lastPage: result.data.lastPage,
    };
  };

  const handleChangeJudgmentPlace = (_event, newValue) => {
    setFormState(formState => ({
      ...formState,
      place: newValue ? newValue : null,
    }));
    setKey(!key);
  };

  const handleSendTask = event => {
    event.preventDefault();

    const { place } = formState;

    if (!place || place === '') {
      toast.warn('Informe uma Vara/Local para prosseguir');
      return;
    }

    addTask(formState);
  };

  const addTask = async params => {
    setSendRequest(true);
    await movementTaskService
      .registerMovementTasksService(params)
      .then(() => {
        sendTramition();
      })
      .catch(() => {
        setSendRequest(false);
      });
  };

  const sendTramition = async () => {
    await movementTaskService
      .movementTaskStartService(inquiry.id)
      .then(() => {
        toast.success('Inquérito enviado para a fase de Denúncia');
        setFormState({ ...initialValues });
        setTimeout(() => {
          onClose();
        }, 1500);
      })
      .finally(() => setSendRequest(false));
  };

  return (
    <div>
      <Dialog fullScreen={fullScreen} open={open} onClose={onClose} maxWidth="md" fullWidth>
        <HeaderModal onClose={onClose}>Enviar inquérito para Denúncia</HeaderModal>
        <DialogContent>
          <form onSubmit={handleSendTask} id="formComplaint">
            <Grid container spacing={1}>
              <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                <LazyAutocomplete
                  autoHighlight
                  onChange={handleChangeJudgmentPlace}
                  value={formState.place || null}
                  key={key}
                  includeInputInList
                  filterSelectedOptions
                  getOptionLabel={option => option?.name || ''}
                  renderOption={(props, option) => (
                    <li {...props}>
                      {option.name}
                    </li>
                  )}
                  enablePagination
                  fetchOptions={fetchDelegacias}
                  renderInput={params => (
                    <InputConsensus
                      {...params}
                      name="place"
                      label="Vara/Local"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <ButtonConsensus
            title="Cancelar"
            backgroundColor="#fff"
            hovercolor={colors.greySecundary}
            color={colors.greyShadow}
            onClick={onClose}
          />
          <ButtonConsensus
            title="Confirmar"
            backgroundColor={colors.greenLight}
            hovercolor={colors.greenLight}
            form="formComplaint"
            type="submit"
            disabled={sendRequest}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalIntimationToComplaint;
